export default __webpack_public_path__ + "static/media/help_2_minimap.f6b86242.gif";